import { Component, ReactNode } from "react"
import { Box, Typography, Button } from "@mui/material"

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("ErrorBoundary caught:", error, info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="100vh"
          gap={2}
        >
          <Typography variant="h5">Algo deu errado</Typography>
          <Typography color="text.secondary">
            Ocorreu um erro inesperado. Tente recarregar a página.
          </Typography>
          <Button
            variant="contained"
            onClick={() => window.location.reload()}
          >
            Recarregar página
          </Button>
        </Box>
      )
    }

    return this.props.children
  }
}
